// extracted by mini-css-extract-plugin
export var black = "_3j-6";
export var brand = "_3j-1";
export var ddefault = "_3j-0";
export var error = "_3j-3";
export var gray = "_3j-2";
export var highContrast = "_3j-8";
export var outline = "_3j-7";
export var success = "_3j-5";
export var warning = "_3j-4";